import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { GtwElementsBaseUrlsModel } from '../../../shared/_models/gtw-elements-base-urls.model';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  buildHeaderDataShell,
  extractObject,
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-data-produce-5471',
    templateUrl: './data-produce-5471.component.html',
    styleUrls: ['./data-produce-5471.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DataProduce5471Component implements OnInit, OnDestroy {

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  private isInitialized = false;
  private readonly contextSubs = new Subscription();
  private contextEpoch = 0;

  baseURLs: GtwElementsBaseUrlsModel = { admin: '', api: '', custom: '', efile: '', pdfEngine: '', bulkPdfEngine: '' };
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  filterParams: any = {};
  rowData: any = {};

  report: any[] = [
    { LEID: '000CH9', tax_code: '840', rpt_pd: '1', bsla: 'CSXUKB-GE Capital EMEA Head Quarters', currency: 'USD', legal_entity: 'GE Capital Sigma Holding Ltd', work_in_progress: 'E&P Adjustments' },
    { LEID: '000CGM', tax_code: '840', rpt_pd: '1', bsla: 'CSXUKB-GE Capital EMEA Head Quarters', currency: 'USD', legal_entity: 'GE Capital Corporation(Holding)', work_in_progress: 'Review Submission Summary and Sign-off(II)' },
    { LEID: '000CGM', tax_code: '840', rpt_pd: '1', bsla: 'CSXUKB-GE Capital EMEA Head Quarters', currency: 'USD', legal_entity: 'GE Capital Corporation(Holding)', work_in_progress: 'Review Submission Summary and Sign-off(II)' },
    { LEID: '000CH9', tax_code: '840', rpt_pd: '1', bsla: 'ADMINSTRATION DOMESTIC', currency: 'USD', legal_entity: 'GE Capital Corporation(Holding)', work_in_progress: 'Review Submission Summary and Sign-off(II)' },
    { LEID: '000CH9', tax_code: '247', rpt_pd: '1', bsla: 'ADMINSTRATION DOMESTIC', currency: 'EUR', legal_entity: 'GE Capital Sigma Holding Ltd', work_in_progress: 'Review Submission Summary and Sign-off(II)' },
    { LEID: '000CH9', tax_code: '247', rpt_pd: '1', bsla: 'ADMINSTRATION DOMESTIC', currency: 'EUR', legal_entity: 'GE Capital Corporation(Holding)', work_in_progress: 'Review Submission Summary and Sign-off(II)' },
    { LEID: '000CH9', tax_code: '247', rpt_pd: '1', bsla: 'ADMINSTRATION DOMESTIC', currency: 'EUR', legal_entity: 'GE Capital Corporation(Holding)', work_in_progress: 'Adjust Prior Year Data/Set Beginning Balances' },
    { LEID: '000CGM', tax_code: '247', rpt_pd: '1', bsla: 'ADMINSTRATION DOMESTIC', currency: 'EUR', legal_entity: 'GE Capital Corporation(Holding)', work_in_progress: 'Adjust Prior Year Data/Set Beginning Balances' },
    { LEID: '000CGM', tax_code: '247', rpt_pd: '1', bsla: 'ADMUKL-LEEDS', currency: 'AUS', legal_entity: 'GE Capital Corporation(Holding)', work_in_progress: 'Review Submission Summary and Sign-off(II)' },
    { LEID: '000CGM', tax_code: '247', rpt_pd: '1', bsla: 'ADMUKL-LEEDS', currency: 'AUS', legal_entity: 'GE Capital Corporation(Holding)', work_in_progress: 'Review Submission Summary and Sign-off(II)' },
    { LEID: '000CGM', tax_code: '247', rpt_pd: '1', bsla: 'ADMUKL-LEEDS', currency: 'AUS', legal_entity: 'GE Capital Corporation(Holding)', work_in_progress: 'Review Submission Summary and Sign-off(II)' }
  ];

  constructor(
    private cdr: ChangeDetectorRef,
    private gtwSnackbarService: GtwSnackbarService,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {}

  ngOnInit(): void {
    this.resetAndTryInit();
    this.contextSubs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.resetAndTryInit();
      })
    );
    this.contextSubs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.resetAndTryInit();
      })
    );
  }

  ngOnDestroy(): void {
    this.contextEpoch++;
    this.contextSubs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const shell = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    const hydrated = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || {};
    let fp = normalizeFilterParams(activeScreen);
    if (!Object.keys(fp).length) {
      fp = extractObject(hydrated);
    }
    this.filterParams = fp;
    const mergedGp = { ...extractObject(shell.globalParams), ...extractObject(hydrated) };
    this.globalService = {
      ...shell,
      globalParams: mergedGp,
      filterParams: fp,
      workspaceFactory: this.gtwWorkspace.workspaceFactory,
      getScenario: (ty: any) => this.gtwGlobal.getScenario(ty),
      getEIN: () => this.gtwGlobal.getEIN(),
      getTAXYEAR: () => this.gtwGlobal.getTAXYEAR(),
      getChartType: () => this.gtwGlobal.getChartType(),
      inputs: this.gtwGlobal.inputs,
      sso_id: this.gtwApp?.USER_SETTINGS?.user?.sso_id ?? ''
    };
    const gc = generalConfigFromGlobal(this.gtwGlobal);
    this.GENERAL_CONFIG = { ...gc, base_url: gc.base_url || gc.api || '' };
    this.baseURLs = gc;
    const rawRow = rowPayloadFromActiveScreen(activeScreen);
    this.rowData = Array.isArray(rawRow)
      ? extractObject(rawRow[0]?.data ?? rawRow[0])
      : extractObject(rawRow);
  }

  private resetAndTryInit(): void {
    this.contextEpoch++;
    this.isInitialized = false;
    this.applyWorkspaceContext();
    this.tryInit();
    this.cdr.markForCheck();
  }

  private tryInit() {
    if (this.isInitialized) return;
    if (!this.GENERAL_CONFIG || Object.keys(this.GENERAL_CONFIG).length === 0) return;
    this.isInitialized = true;
    this.init();
  }

  private init() {
    this.cdr.markForCheck();
  }

  save() {
    this.gtwSnackbarService.openSnackBar('Data save Successfully', 'gtw-snackbar--green');
  }

  cancel() {
    this.requestGridUpdate.emit('cancel');
  }
}
